import CrudCustom from '../../../libs/custom/CrudCustom';

let SummaryUnifikasiService = new CrudCustom('/view-summary-unifikasi');
export default SummaryUnifikasiService;
